let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ctZCD"), load("6jNWq")]).then(() => parcelRequire('5n8d3'));